<template>
  <section>
    <SectionContainer variant="gray">
      <CoursesInProgressSection />
    </SectionContainer>

    <SectionContainer>
      <MyCoursesSection />
    </SectionContainer>

    <SectionContainer>
      <LivesSection />
    </SectionContainer>

    <SectionContainer variant="gray">
      <SuggestionCourses name="Design e vídeo" class="mb-5" />
      <SuggestionCourses name="Design e vídeo" class="mb-5" />
      <SuggestionCourses name="Design e vídeo" class="mb-5" />
      <SuggestionCourses name="Design e vídeo" class="mb-5" />
      <SuggestionCourses name="Design e vídeo" class="mb-5" />
    </SectionContainer>
  </section>
</template>

<script>
  import SectionContainer from '@/components/layout/SectionContainer'
  import CoursesInProgressSection from '@/components/user/dashboard/CoursesInProgressSection'
  import MyCoursesSection from '@/components/user/dashboard/MyCoursesSection'
  import LivesSection from '@/components/user/dashboard/LivesSection'
  import SuggestionCourses from '@/components/user/dashboard/SuggestionCourses'

  export default {
    components: {
      CoursesInProgressSection,
      SectionContainer,
      MyCoursesSection,
      LivesSection,
      SuggestionCourses,
    }
  }
</script>